/**
 * Count input with increment (+) and decrement (-) buttons
 */

export default (() => {
  const countInputs = document.querySelectorAll('.count-input-js')

  const handleIncrement = (event) => {
    const input = getInputFromEvent(event)
    input.value++
    updateDecrementButtonState(input)
    updateInputSize(input)
  }

  const handleDecrement = (event) => {
    const input = getInputFromEvent(event)
    if (input.value > 0) {
      input.value--
    }
    updateDecrementButtonState(input)
    updateInputSize(input)
  }

  const handleInputChange = (event) => {
    const input = getInputFromEvent(event)
    updateDecrementButtonState(input)
    updateInputSize(input)
  }

  const updateDecrementButtonState = (input) => {
    const decrementBtn = input.parentNode.querySelector('[data-decrement]')
    decrementBtn.disabled = input.value <= 0
  }

  const updateInputSize = (input) => {
    input.style.width = input.value.toString().length + 'ch'
  }

  const getInputFromEvent = (event) => {
    return event.currentTarget.parentNode.querySelector('.form-control')
  }

  countInputs.forEach((component) => {
    const incrementBtn = component.querySelector('[data-increment]')
    const decrementBtn = component.querySelector('[data-decrement]')
    const input = component.querySelector('.form-control')

    incrementBtn.addEventListener('click', handleIncrement)
    decrementBtn.addEventListener('click', handleDecrement)
    input.addEventListener('input', handleInputChange)

    updateDecrementButtonState(input)
    updateInputSize(input)
  })
})()
